// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-chatstyle {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 90vh;
  overflow: hidden;
}
.messages-roam-viever-scrollable-div {
  flex-grow: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column-reverse;
  padding: 20px;
  height: 73vh;
}
.messages-roam-viever-infinite-scroll {
  display: flex;
  flex-direction: column-reverse;
}
.message-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
}
.message-container.self {
  justify-content: flex-end;
}
.message-container.other {
  justify-content: flex-start;
}
.avatar {
  margin-right: 10px !important;
  font-weight: bold !important;
  font-size: 16px !important;
  width: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
}
.message-content {
  padding: 8px;
  border-radius: 12px;
  background-color: #f1f1f1;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  max-width: 70%;
}
.message-container.self .message-content {
  background-color: #d0e6f8;
}
.message-container.other .message-content {
  background-color: #f1f1f1;
}
.message-author {
  font-weight: bold;
  margin-bottom: 5px;
}
.message-text {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.message-datetime {
  text-align: right;
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  align-self: flex-end;
}
.date-divider {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}
.date-divider-content {
  background-color: #f1f1f1;
  color: #374151;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.5px;
}
.scroll-to-bottom-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.3s ease;
  opacity: 0;
  visibility: hidden;
}
.scroll-to-bottom-btn.visible {
  opacity: 1;
  visibility: visible;
}
.scroll-to-bottom-btn:hover {
  background-color: #f0f0f0;
}
.scroll-to-bottom-btn-icon {
  font-size: 20px;
  color: gray;
}
`, "",{"version":3,"sources":["webpack://./src/components/support-chat/components/styles.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AACF;AAEA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,YAAA;AAAF;AAGA;EACE,aAAA;EACA,8BAAA;AADF;AAIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAFF;AAIE;EACE,yBAAA;AAFJ;AAKE;EACE,2BAAA;AAHJ;AAOA;EACE,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;AALF;AAQA;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,wCAAA;EACA,cAAA;AANF;AASA;EACE,yBAAA;AAPF;AAUA;EACE,yBAAA;AARF;AAWA;EACE,iBAAA;EACA,kBAAA;AATF;AAYA;EACE,qBAAA;EACA,qBAAA;AAVF;AAaA;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;AAXF;AAcA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAZF;AAeA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,wCAAA;EACA,qBAAA;AAbF;AAgBA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;AAdF;AAiBA;EACE,UAAA;EACA,mBAAA;AAfF;AAkBA;EACE,yBAAA;AAhBF;AAmBA;EACE,eAAA;EACA,WAAA;AAjBF","sourcesContent":[".my-chatstyle {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-height: 90vh;\n  overflow: hidden;\n}\n\n.messages-roam-viever-scrollable-div {\n  flex-grow: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column-reverse;\n  padding: 20px;\n  height: 73vh;\n}\n\n.messages-roam-viever-infinite-scroll {\n  display: flex;\n  flex-direction: column-reverse;\n}\n\n.message-container {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 16px;\n\n  &.self {\n    justify-content: flex-end;\n  }\n\n  &.other {\n    justify-content: flex-start;\n  }\n}\n\n.avatar {\n  margin-right: 10px !important;\n  font-weight: bold !important;\n  font-size: 16px !important;\n  width: 40px !important;\n  height: 40px !important;\n  line-height: 40px !important;\n}\n\n.message-content {\n  padding: 8px;\n  border-radius: 12px;\n  background-color: #f1f1f1;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  max-width: 70%;\n}\n\n.message-container.self .message-content {\n  background-color: #d0e6f8;\n}\n\n.message-container.other .message-content {\n  background-color: #f1f1f1;\n}\n\n.message-author {\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.message-text {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.message-datetime {\n  text-align: right;\n  font-size: 12px;\n  color: #999;\n  margin-top: 8px;\n  align-self: flex-end;\n}\n\n.date-divider {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 20px 0;\n}\n\n.date-divider-content {\n  background-color: #f1f1f1;\n  color: #374151;\n  padding: 6px 16px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.5px;\n}\n\n.scroll-to-bottom-btn {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: opacity 0.3s ease;\n  opacity: 0;\n  visibility: hidden;\n}\n\n.scroll-to-bottom-btn.visible {\n  opacity: 1;\n  visibility: visible;\n}\n\n.scroll-to-bottom-btn:hover {\n  background-color: #f0f0f0;\n}\n\n.scroll-to-bottom-btn-icon {\n  font-size: 20px;\n  color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
